import posthog from "posthog-js";
import { toast } from "sonner";
import {
  multiPersonCastPhotoCopy,
  multiPersonCastPhotoWarning,
} from "@shared/multiPersonCastPhoto";

/**
 * Toast the "this photo shows N people" warning for a just-added cast photo
 * (see shared/multiPersonCastPhoto.ts) and log it. Returns whether it
 * warned; a photo of one person, or one the classifier could not read, stays
 * silent.
 */
export function toastMultiPersonCastPhoto(input: {
  subjectCount: unknown;
  /** People photos the surface still accepts besides this one. */
  freeSlots: number;
  /** Analytics surface of the character_photo_multi_person_warning event. */
  surface: string;
}): boolean {
  const warning = multiPersonCastPhotoWarning(input);
  if (!warning) return false;
  posthog.capture("character_photo_multi_person_warning", {
    surface: input.surface,
    subject_count: warning.count,
  });
  const copy = multiPersonCastPhotoCopy(warning);
  toast.warning(copy.title, { description: copy.body, duration: 9000 });
  return true;
}
